export interface StoredToolIcon {
  icon: string
  colorClass?: string
}

const TOOL_ICONS_STORAGE_KEY = 'tool-icons'
const LEGACY_TOOL_EMOJI_STORAGE_KEY = 'tool-emojis'

export function loadToolIconsMap(): Record<string, StoredToolIcon> {
  if (typeof window === 'undefined') return {}
  let next: Record<string, StoredToolIcon> = {}
  try {
    const raw = window.localStorage.getItem(TOOL_ICONS_STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      if (parsed && typeof parsed === 'object') {
        next = parsed as Record<string, StoredToolIcon>
      }
    }
  } catch {
    next = {}
  }

  // Backward compatibility: migrate legacy emoji-only map.
  try {
    const legacyRaw = window.localStorage.getItem(LEGACY_TOOL_EMOJI_STORAGE_KEY)
    if (legacyRaw) {
      const parsedLegacy = JSON.parse(legacyRaw) as Record<string, string>
      Object.entries(parsedLegacy || {}).forEach(([toolId, emoji]) => {
        if (!next[toolId] && emoji) {
          next[toolId] = { icon: `emoji:${emoji}` }
        }
      })
    }
  } catch {
    // Ignore legacy parse errors.
  }

  return next
}

export function saveToolIcon(toolId: string, value: StoredToolIcon | null) {
  if (typeof window === 'undefined') return
  const map = loadToolIconsMap()
  if (!value || !value.icon) {
    delete map[toolId]
  } else {
    map[toolId] = value
  }
  window.localStorage.setItem(TOOL_ICONS_STORAGE_KEY, JSON.stringify(map))
}

